import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { LoadingModule } from '../../shared/ui/loading/loading.module'
import { ToggleAdvancedEditModule } from '../../shared/ui/toggle-advanced-edit/toggle-advanced-edit.module'
import { LoginComponent } from './login.component'
import { PasswordResetDialogComponent } from './dialogs/password-reset-dialog.component'

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        LoadingModule,
        ToggleAdvancedEditModule,
    ],
    declarations: [
        LoginComponent,
        PasswordResetDialogComponent,
    ],
})
export class LoginModule {
}
